import { AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

const AccordionSummaryComponent: React.FC<any> = () => {
    const { t } = useTranslation();

    return (
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
            <Typography>{t('allowedHosts')}</Typography>
        </AccordionSummary>
    );
};

export default AccordionSummaryComponent;
